import {withStyles} from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";

export const Accordion = withStyles({
    root: {
        borderRadius: '15px',
        marginBottom: '0.5em',
        borderBottom: 'none',
        '&:before': {
            display: 'none',
        },
        '&:last-child': {
            border: 'none',
            borderRadius: '15px',
        },
        '&:first-child': {
            border: 'none',
            borderRadius: '15px',
        },
    },
})(MuiAccordion);